// Users / team management (pages/Users.jsx): assistant role and clinic team mode.
const strings = {
  es: {
    team_sub: "Da acceso a los médicos y asistentes de tu clínica y define a qué médicos apoya cada asistente.",
    role_assistant_desc: "Apoya a médicos asignados: agenda, confirma citas y da seguimiento a pacientes. No ve el expediente clínico.",
    assigned_doctors: "Médicos asignados",
    assigned_doctors_hint: "El asistente solo verá los pacientes y citas de estos médicos.",
    assistant_move_hint: "Al cambiar de clínica se quitan sus médicos asignados.",
    no_doctors_in_clinic: "Esta clínica aún no tiene médicos activos.",
    assists: "Apoya a",
    no_assigned_doctors: "Sin médicos asignados",
    perm_team_clinic: "Su equipo",
    perm_scoped_assigned: "Sus médicos asignados",
    perm_demographics_assigned: "Datos generales (sus médicos)",
    perm_branding: "Marca de la plataforma",
    perm_followups: "Confirmaciones y seguimiento",
  },
  en: {
    team_sub: "Give your clinic's doctors and assistants access, and choose which doctors each assistant supports.",
    role_assistant_desc: "Supports assigned doctors: schedules, confirms appointments and follows up with patients. Can't see the clinical record.",
    assigned_doctors: "Assigned doctors",
    assigned_doctors_hint: "The assistant will only see these doctors' patients and appointments.",
    assistant_move_hint: "Moving to another clinic removes their assigned doctors.",
    no_doctors_in_clinic: "This clinic has no active doctors yet.",
    assists: "Supports",
    no_assigned_doctors: "No assigned doctors",
    perm_team_clinic: "Their team",
    perm_scoped_assigned: "Their assigned doctors",
    perm_demographics_assigned: "General data (their doctors)",
    perm_branding: "Platform branding",
    perm_followups: "Confirmations & follow-up",
  },
};

export default strings;
